const KEY = "bpv_resume";
const MAX = 60;

const readAll = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "{}");
    return v && typeof v === "object" ? v : {};
  } catch {
    return {};
  }
};

export const getResume = (id) => readAll()[id] || null;

export const saveResume = (id, t, d) => {
  const all = readAll();
  if (!d || t < 5 || t > d - 15) {
    delete all[id];
  } else {
    all[id] = { t: Math.floor(t), d: Math.floor(d), at: Date.now() };
  }
  const trimmed = Object.entries(all).sort((a, b) => b[1].at - a[1].at).slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(trimmed)));
};

export const clearResume = (id) => saveResume(id, 0, 0);
